import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { Outlet, useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import CustomMenuList from "./Menu";
import { Button, Grid, Stack, Typography } from "@mui/material";
import "./style.css";
import DrawIcon from "@mui/icons-material/Draw";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import { useTheme, useMediaQuery } from "@mui/material";
import Patrocinadores from "./Patrocinadores";
import HotelIcon from '@mui/icons-material/Hotel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const pages = [
  {
    label: "CLADE 2026",
    href: "/",
    target: "_self",
  },
  {
    label: "Patrocinio",
    href: "/patrocinio",
    target: "_self",
  },
  {
    label: "Programa Preliminar",
    href: "/programa",
    target: "_self",

  },
  {
    label: "Tarifas",
    href: "/tarifas",
    target: "_self",

  },
  {
    label: "Tours",
    href: "/tours",
    target: "_self",
  },
  {
    label: "Registro",
    href: "https://registro.felaban.net/congreso/91",
    target: "_blank",
  },
  {
    label: "Contacto",
    href: "/contacto",
    target: "_self",
  },

  {
    label: "OPCIONES DE HOSPEDAJE",
    submenu: [
      {
        label: "Hotel Barceló",
        href: "https://reservation.barcelo.com/?be_redirect=ceres&country=GT&rooms=1&arrive=2026-05-20&marketcampaign=cam&hotel=7319&currency=USD&store=es-cr&depart=2026-05-21&adult=2&locale=es-AR&marketprice=CAM&groupcode=ASOCBAN26",
      },
      /*      {
              label: "Hotel Biltmore",
              href: "https://caminobiltmore-guatemala.ihotelier.com/book/dates-of-stay?groupID=5229234",
            },*/
    ],
  },

];

const live_events_service = require('../../helpers/live_events_service')

function ScrollTop(props) {
  const { children, windowRef } = props;
  const trigger = useScrollTrigger({
    target: windowRef ? windowRef() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

// Componente para el botón de hospedaje en desktop
function HospedajeDropdown() {
  const navigate = useNavigate();

  return (
    <Button
      id="hospedaje-button"
      onClick={() => navigate("/hospedaje")}
      sx={{
        color: "#1e3d52",
        fontWeight: "bold",
        textTransform: "none",
        fontSize: "1rem",
        '&:hover': {
          backgroundColor: 'rgba(30, 61, 82, 0.04)',
        },
      }}
    >
      OPCIONES DE HOSPEDAJE
    </Button>
  );
}

export default function Layout(props) {
  const [contador] = useState(0);
  const [evento, setEvento] = useState({});
  const [programa, setPrograma] = useState({});
  const [patrocinadores, setPatrocinadores] = useState([]);
  const [patrocinadores_diamante, setPatrocinadores_diamante] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    live_events_service
      .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
      .then((response_evt) => {
        live_events_service
          .getData(
            "/patrocinador/view-by-evento/" +
            process.env.REACT_APP_EVT
          )
          .then((response_patrocinador) => {
            setEvento(response_evt.data.response_database.result[0]);
            setPatrocinadores(response_patrocinador.data.response.result);
            setPatrocinadores_diamante(response_patrocinador.data.response.result.filter((patrocinador) => patrocinador.tipo === "DIAMANTE"));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [contador]);

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
      elevation: trigger ? 4 : 0,
    });
  }

  ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar
          position={isMobile ? "static" : "static"}
          style={{
            backgroundColor: "white",
            color: "#1e3d52",
          }}
        >
          <Box style={{ width: "100%", padding: '2%' }}>
            <Grid container style={{ width: '100%' }} spacing={3} alignItems="center" justifyContent="center">
              {/* Columna Izquierda - Primeras dos imágenes */}
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid container spacing={2} justifyContent="center">
                  <Grid size={{ xs: 10, sm: 10 }}>
                    <img
                      src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/37460b05-fbb4-4578-b54f-d2c3c90c0f42.png"
                      loading="lazy"
                      className="img-header"
                      style={{ width: '100%', display: 'block' }}
                    />
                  </Grid>

                </Grid>
              </Grid>



              {/* Columna Centro - Logo CLADIT Principal (solo visible en desktop) */}
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ display: { xs: 'flex', sm: 'flex', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src="/logo-clade.png"
                  loading="lazy"
                  className="img-header"
                  style={{ width: '90%', maxWidth: '300px', display: 'block' }}
                />
              </Grid>

              {/* Columna Derecha - Patrocinadores Diamante */}
              <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Stack direction="column" spacing={2} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
                  <img
                    src="/felaban.png"
                    alt="FELABAN"
                    loading="lazy"
                    style={{ width: '90%', maxWidth: '200px', display: 'block' }}
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      textAlign: 'center',
                      width: '100%',
                      fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
                      color: '#1e3d52'
                    }}
                  >
                    Patrocinadores Diamante
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: '100%',
                      flexWrap: 'wrap',
                      gap: '1rem'
                    }}
                  >
                    {patrocinadores_diamante && patrocinadores_diamante.map((patrocinador, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: { xs: '60px', sm: '70px', md: '80px' },
                          height: { xs: '60px', sm: '70px', md: '80px' },
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        <img
                          src={patrocinador.promocional_landing}
                          loading="lazy"
                          className="img-patrocinador"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      </Box>
                    ))}
                  </Stack>
                </Stack>
              </Grid>
              <Grid size={{ xs: 12, lg: 12, md: 2 }} >
                <Grid container style={{ width: '100%' }} alignContent='center' alignItems='center' justifyContent='center' spacing={1}>
                  <Grid size={{ xs: 6, lg: 6, md: 6 }} style={{ textAlign: 'center' }} >
                    <Button style={{ color: 'black' }} startIcon={<WhatsAppIcon style={{ color: '#25D366' }} />} href="https://wa.me/50223827200" target="_blank" > +502 2382-7200</Button>
                  </Grid>
                  <Grid size={{ xs: 6, lg: 6, md: 6 }} style={{ textAlign: 'center' }}>
                    <Stack spacing={2} style={{ width: "100%" }} alignItems="center" justifyContent="center">
                      <Button style={{ color: 'black' }} startIcon={<EmailIcon />} href="mailto:ncuches@ebg.edu.gt?subject=Solicitud%20de%20reunión%20para%20más%20información%20de%20CLADIT%202026" >Solicitar una reunión</Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              <Stack spacing={2} style={{ width: "100%" }}>
                <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                      display: { xs: "block", md: "none" },
                    }}
                  >
                    {pages.map((page, index) => (
                      <div key={`MENU-ITEM-${index}`}>
                        {page.submenu ? (
                          <MenuItem
                            onClick={() => {
                              window.location.href = "/hospedaje";
                              handleCloseNavMenu();
                            }}
                          >
                            <HotelIcon sx={{ mr: 1, fontSize: 18, color: "#1e3d52" }} />
                            <ListItemText style={{ color: "#1e3d52", fontWeight: "bold" }}>
                              {page.label}
                            </ListItemText>
                          </MenuItem>
                        ) : (
                          <MenuItem
                            onClick={() => {
                              if (page.target === "_blank") {
                                window.open(page.href, '_blank');
                              } else {
                                window.location.href = page.href;
                              }
                            }}
                          >
                            <ListItemText
                              style={{ color: "#1e3d52", fontWeight: "bold" }}
                            >
                              {page.label}
                            </ListItemText>
                          </MenuItem>
                        )}
                      </div>
                    ))}
                  </Menu>
                </Box>
                <Box
                  sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  {pages.map((page, index) => (
                    <div key={`MENU-ITEM-${index}`}>
                      {page.submenu ? (
                        <HospedajeDropdown />
                      ) : (
                        <MenuItem
                          onClick={handleCloseNavMenu}
                        >
                          <CustomMenuList title={page.label} href={page.href} target={page.target} />
                        </MenuItem>
                      )}
                    </div>
                  ))}
                </Box>
              </Stack>
            </Toolbar>
          </Container>
        </AppBar>
      </ElevationScroll>
      <Box id="back-to-top-anchor">
        <Stack spacing={2} style={{ width: "100%" }} alignItems="center" justifyContent="center">
          <Outlet />
          <Patrocinadores />
        </Stack>
      </Box>
      <ScrollTop {...props}>
        <Stack spacing={2} >
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
          <Fab
            variant="extended"
onClick={()=>{window.open(`https://registro.felaban.net/congreso/91`, "_blank")}}          
          >
            <DrawIcon sx={{ mr: 1 }} />
            Inscríbete en Línea
          </Fab>
        </Stack>
      </ScrollTop>
    </React.Fragment>
  );
}